



































































































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import { State } from 'vuex-class'
import UserGroup from '../../../user/model/UserGroup'
import AppReleaseSelect from '@/modules/app-router/components/AppRelease/AppReleaseSelect.vue'
import GroupReleaseAssignation from '@/modules/app-router/model/GroupReleaseAssignation';
import AppRelease from '@/modules/app-router/model/AppRelease';
import {Colors, notify} from '@/modules/core/notification';
import UserListWidget from '@/modules/user/components/UserListWidget.vue';
import Wamp from '@/modules/core/wamp/mixins/Wamp';
/**
 * Versiones para grupos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {UserListWidget, AppReleaseSelect },
})
export default class VersionsForGroups extends mixins(Wamp) {
    /**
     * Grupos de usuarios registrados en la aplicación
     *
     * @var { UserGroup[] }
     */
    @State(state => state.user.userGroups)
    public groups: UserGroup[]

    /**
     * Lista de asignaciones de distribuciones a grupos de
     * usuarios
     *
     * @var { GroupReleaseAssignation[] }
     */
    @State(state => state.appRouter.groupReleaseAssignations)
    public assignations: GroupReleaseAssignation[]

    public loading = false
    public saveConfirm = false
    public saving = false
    public search = ''
    public searchDialog = false
    public notifyVersionChange = false

    public releaseSelectBottomSheet = false
    public currentRelease = new AppRelease()
    public currentGroup = new UserGroup()

    /**
     * Al crear el componente carga la lista de asignaciones
     */
    public async created () {
        this.loading = true
        // Carga la lista de usuarios
        await this.$store.dispatch('user/loadUserGroups', {force: true})
        await this.$store.dispatch(
            'appRouter/loadGroupReleaseAssignations',
        )

        this.loading = false
    }

    /**
     * Permite obtener la distribución configurar para el
     * grupo argumentado
     */
    public releaseOf (group: UserGroup) {
        const assignation = this.assignations.find(a => a.group.id === group.id)
        if (!assignation) {
            return null
        }

        return assignation.release
    }

    /**
     * Guarda los cambios realizados sobre la lista de asignaciones
     */
    public async save () {
        this.saving = true
        await this.$store.dispatch('appRouter/saveGroupReleaseAssignations')

        this.saveConfirm = false
        this.saving = false

        if (this.notifyVersionChange) {
            await this.$wamp.connect()
            await this.$wamp.publish('net.unigest.version_changed_notification', [], {}, {acknowledge: true})
        }

        notify('Las asignaciones de distribuciones a grupos se han guardado correctamente')
    }

    /**
     * Cualquier error producido durante el ciclo de vida del componente
     * será interceptado y notificado al usuario.
     *
     * El componente volverá a un estado seguro
     */
    public errorCaptured (e: Error) {
        this.saving = false
        this.saveConfirm = false

        notify(`Se ha producido un error: ${e.message}`, Colors.Error)
    }
}
